// extracted by mini-css-extract-plugin
export default {"nutritionBox":"CzwyPSmV1EpJ5tMXNsij","nutritionItem":"JK7DximqxeCYAHTFGUj0","label":"zy3Pd94PFfk2N4CDGEWc","value":"V_b1uMP4EW2uIUygsN4d","alert":"K6XweDvzOxQDfXwxaxpp"};